export default __webpack_public_path__ + "static/media/logo-package-dubbing-en.759c70c2.png";